import { h } from 'preact';

export function IconExplicit({ width = 16, height = 16, fill = 'currentColor', class: className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill={fill}
      width={width}
      height={height}
      class={`icon-explicit${className ? ` ${className}` : ''}`}
    >
      <path d="M869.1,0H154.9C69.3,0,0,69.3,0,154.9v714.3c0,85.5,69.3,154.9,154.9,154.9h714.3c85.5,0,154.9-69.3,154.9-154.9V154.9c0-85.5-69.3-154.9-154.9-154.9h0ZM706,811h-402.6V213h402.1v121.6h-262.7v113.2h248.4v115.7h-248.4v124.2h263.2" />
    </svg>
  );
}
